import { useEffect, useState } from "react";
import { API_BASE } from "../api/config";
import Layout from "../components/Layout";

function Company() {
  const [formData, setFormData] = useState({
    company_name: "",
    mobile: "",
    gstin: "",
    address: "",
    city: "",
    state: "",
    country: "",
    terms_and_conditions: "",
  });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  // Fetch company data
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await fetch(
          `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=company`
        );
        const data = await response.json();

        if (data.status === "ok" && data.data.length > 0) {
          setFormData({
            company_name: data.data[0].company_name || "",
            mobile: data.data[0].proprietor_mobile || "",
            gstin: data.data[0].gstin_number || "",
            address: data.data[0].address || "",
            city: data.data[0].city || "",
            state: data.data[0].state || "",
            country: data.data[0].country || "",
            terms_and_conditions: data.data[0].terms_and_conditions || "",
          });
        } else {
          setMessage("No company data found ❌");
        }
      } catch (error) {
        console.error("Error fetching company:", error);
        setMessage("Error loading data ❌");
      } finally {
        setLoading(false);
      }
    };

    fetchCompany();
  }, []);

  // Handle form field changes
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // Update company data
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("Updating...");

    try {
      const response = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=update_company`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();
      if (result?.status === "ok") {
        setMessage("✅ Company updated successfully!");
      } else {
        setMessage("❌ Update failed. Please try again.");
      }
    } catch (error) {
      console.error("Update error:", error);
      setMessage("❌ Something went wrong.");
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="p-6 text-center text-lg">Loading company data...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="p-6 max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold text-white-800 mb-6">
          Company Info
        </h1>

        <form
          onSubmit={handleSubmit}
          className="bg-white shadow-lg rounded-2xl p-6 space-y-4"
        >
          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              Company Name
            </label>
            <input
              type="text"
              name="company_name"
              value={formData.company_name}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 text-black"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              Mobile
            </label>
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 text-black"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              GSTIN
            </label>
            <input
              type="text"
              name="gstin"
              value={formData.gstin}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 text-black"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              Address
            </label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 text-black"
              rows="3"
            ></textarea>
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              City
            </label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 text-black"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              State
            </label>
            <input
              type="text"
              name="state"
              value={formData.state}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 text-black"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              Country
            </label>
            <input
              type="text"
              name="country"
              value={formData.country}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 text-black"
            />
          </div>

          {/* ✅ Terms and Conditions */}
          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              Terms & Conditions
            </label>
            <textarea
              name="terms_and_conditions"
              value={formData.terms_and_conditions}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 text-black"
              rows="4"
              placeholder="Enter terms and conditions..."
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full bg-gradient-to-r from-blue-700 to-orange-500 text-white py-2 rounded-lg font-semibold hover:opacity-90 transition"
          >
            Update Company
          </button>

          {/* ✅ Show message below the button */}
          {message && (
            <p className="mt-3 text-center text-sm font-medium text-gray-700">
              {message}
            </p>
          )}
        </form>
      </div>
    </Layout>
  );
}

export default Company;
